export function PlatformIndicator({platformCode}) {
    const style = { 
      padding: '.2rem',
      whiteSpace: 'nowrap', 
      borderStyle: 'dotted', 
      borderWidth: '1px', 
      cursor: 'default',
      display: 'inline-block',
    }
  
    if (platformCode) {
      return <b className='text-xs text-300 ml-1' style={style} title={'Stanowisko: ' + platformCode}>{platformCode}</b>
    } else {
      return <></>;
    }
    
  }